import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../images/services-usa/chatbot-new/integerate_back.webp";

function Chatbotintegeration() {
  return (
    <section
      className="chatbot_integeration"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>Integrate Chatbots for a Seamless Customer Experience!</h2>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Discuss Your Idea
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="text-center">
            <div className="chatbot_int_img">
              <StaticImage
                src="../../images/services-usa/chatbot-new/integerate_chatbot.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={599}
                height={569}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Chatbotintegeration;
